<main class="container my-5 pt-5">
  <div class="container-fluid main-content mt-5">
    <div class="row g-4">
      <!--Row 1: Profile Section-->
      <div class="col-12">
        <div class="custom-card">
          <div class="card-body d-flex flex-column flex-md-row align-items-center">
            <!-- Profile Image and Button -->
            <div class="d-flex flex-column align-items-center me-md-3 mb-3 mb-md-0">
              <img src="{{teacherImg}}" class="img-fluid mb-2" style="width: 150px; height: auto; border-radius: 16px;"
                   alt="Profile Picture">
              <button class="btn btn-primary mt-2" (click)="editProfile()">
                {{ isEditing ? 'Cancel' : 'Edit' }}
              </button>

            </div>

            <!-- Profile Information -->
            <div *ngIf="!isEditing; else editForm" class="text-center text-md-start">
              <h5
                class="custom-card-title">{{ teacher.title }} {{ teacher.fName }} {{ teacher.mInitial }} {{ teacher.lName }}</h5>
              <p class="card-text mb-1">{{ teacher.school }}<span *ngIf="teacher.school">,</span> {{ teacher.grade }}
                <span *ngIf="teacher.grade != 'All Grades'">Grade</span></p>
              <p class="card-text"><span *ngIf="teacher.role">{{ teacher.role }}, </span><a
                [href]="'mailto:' + teacher.email">{{ teacher.email }}</a></p>
              <p class="card-text fw-normal">{{ teacher.bio }}</p>
            </div>

            <ng-template #editForm>
              <div class="mt-3">
                <form>
                  <div class="row g-3 mb-3">
                    <div class="col-md-4">
                      <label for="titleInput" class="form-label">Title</label>
                      <select id="titleInput" class="form-select" [(ngModel)]="teacher.title" name="title">
                        <option value=""></option>
                        <option value="Mrs.">Mrs.</option>
                        <option value="Ms.">Ms.</option>
                        <option value="Mr.">Mr.</option>
                        <option value="Dr.">Dr.</option>
                      </select>
                    </div>

                    <div class="col-md-4">
                      <label for="profileImgInput" class="form-label">Upload Profile Picture</label>
                      <input type="file" id="profileImgInput" class="form-control" name="img">

                    </div>
                  </div>

                  <div class="row g-3">
                    <div class="col-md-4">
                      <label for="fNameInput" class="form-label">First Name</label>
                      <input type="text" id="fNameInput" class="form-control" [(ngModel)]="teacher.fName"
                             name="firstName">
                    </div>

                    <div class="col-md-4">
                      <label for="mInitialInput" class="form-label">Middle Initial</label>
                      <input type="text" id="mInitialInput" class="form-control" maxlength="1"
                             [(ngModel)]="teacher.mInitial" name="middleInitial">
                    </div>

                    <div class="col-md-4">
                      <label for="lNameInput" class="form-label">Last Name</label>
                      <input type="text" id="lNameInput" class="form-control" [(ngModel)]="teacher.lName"
                             name="lastName">
                    </div>

                    <div class="col-md-6">
                      <label for="schoolInput" class="form-label">School</label>
                      <select id="schoolInput" class="form-select" [(ngModel)]="teacher.school" name="school">
                        <option value="">Select School</option>
                        <option *ngFor="let school of schools" [value]="school.name">{{ school.name }}</option>
                      </select>
                    </div>

                    <div class="col-md-6">
                      <label for="gradeInput" class="form-label">Grade</label>
                      <select id="gradeInput" class="form-select" [(ngModel)]="teacher.grade" name="grade">
                        <option value="All Grades">All Grades</option>
                        <option value="K">K</option>
                        <option value="1st">1st</option>
                        <option value="2nd">2nd</option>
                        <option value="3rd">3rd</option>
                        <option value="4th">4th</option>
                        <option value="5th">5th</option>
                        <option value="6th">6th</option>
                        <option value="7th">7th</option>
                        <option value="8th">8th</option>
                        <option value="9th">9th</option>
                        <option value="10th">10th</option>
                        <option value="11th">11th</option>
                        <option value="12th">12th</option>
                      </select>
                    </div>

                    <div class="col-md-12">
                      <label for="bioInput" class="form-label">Bio</label>
                      <textarea id="bioInput" class="form-control" rows="3" maxlength="500" [(ngModel)]="teacher.bio"
                                name="bio"></textarea>
                    </div>
                  </div>

                  <div class="mt-4 d-flex justify-content-end">
                    <button type="button" class="btn btn-primary me-2" (click)="updateProfile()">Save</button>
                    <button type="button" class="btn btn-danger" (click)="editProfile()">Cancel</button>
                  </div>
                </form>
              </div>

            </ng-template>
          </div>
        </div>
      </div>

      <!-- Row 2: School Projects (left side) -->
      <!--<div class="col-lg-6 col-md-6 col-sm-12 pt-3">
        <div class="custom-card mb-4">
          <div class="card-body" style="overflow-y: auto; max-height: 600px;">
            <h5 class="custom-card-title">School Projects</h5>
            <div class="pe-4">
              @for (project of myProjects; track project.id) {
                <app-project-card [project]="project"
                                  (cardClicked)="onProjectCardClicked($event)">
                </app-project-card>
              }
            </div>
            <div *ngIf="!myProjects || myProjects.length === 0" class="text-center text-muted mt-3">
              <p>No school projects found.</p>
            </div>
          </div>
        </div>-->

      <!-- Drafts Box (below School Projects) -->
      <!--<div class="custom-card">
        <div class="card-body" style="overflow-y: auto; max-height: 600px;">
          <h5 class="custom-card-title">Drafts</h5>

          <div *ngIf="draftData && draftData.length > 0; else noDrafts">
            <div *ngFor="let draft of draftData" class="mb-2">
              <p>
                <a href="/new-project?draftId={{ draft.id }}">
                  {{ draft.title || 'Untitled Draft' }}
                </a>
                <small class="text-muted">
                  - Last edited: {{ formatDate(draft.dateEdited) }}
                </small>
              </p>
            </div>
          </div>

          <ng-template #noDrafts>
            <p class="text-muted text-center">No saved drafts</p>
          </ng-template>
        </div>
      </div>
    </div>-->

      <!-- Row 2: My Projects (right side) -->
      <!--<div class="col-lg-6 col-md-6 col-sm-12 pt-3">
        <div class="custom-card">
          <div class="card-body" style="overflow-y: auto; max-height: 600px;">
            <h5 class="custom-card-title">My Projects</h5>
            <div class="pe-4">
              @for (project of myProjects; track project.id) {
                <app-project-card [project]="project"
                                  (cardClicked)="onProjectCardClicked($event)">
                </app-project-card>
              }
            </div>
            <div *ngIf="!myProjects || myProjects.length === 0" class="text-center text-muted mt-3">
              <p>No projects found.</p>
            </div>
          </div>
        </div>
      </div>-->
    </div>
  </div>

  <div class="container-fluid main-content mt-5" *ngIf="teacher.role.toLowerCase() === 'admin'">
    <div class="row g-4">
      <!--Row 1: Profile Section-->
      <div class="col-12">
        <div class="custom-card">
          <div class="mb-1" style="display: flex; justify-content: space-between; align-items: center;">
            <h3>Manage All Profiles</h3>
            <div class="btn btn-outline-primary" style="display: flex; align-items: center;"
                 routerLink="/admin-user-creation">
              Add New User
              <span class="material-symbols-outlined" style="margin-left: 0.3rem;">add</span>
            </div>
          </div>
          <input type="text" class="form-control w-100 mb-3"
                 placeholder="Search by name, email, school or role..."
                 [(ngModel)]="searchTerm" (input)="onSearchChange()">
          <div>
            <div class="row" style="margin: 0" id="row-section">

              <table class="table table-striped">
                <thead>
                <tr>
                  <th>Name</th>
                  <th>Email</th>
                  <th>School</th>
                  <th>Grade</th>
                  <th>Role</th>
                  <th class="text-center">Action</th>
                </tr>
                </thead>

                <tbody>
                <tr *ngFor="let teacher of filteredTeachers; let i = index">
                  <!-- NAME -->
                  <td>
                    <ng-container *ngIf="editingIndex !== i; else editName">
                      {{ teacher.fName }} {{ teacher.lName }}
                    </ng-container>
                    <ng-template #editName>
                      <input class="form-control form-control-sm mb-1"
                             [(ngModel)]="editTeacher.fName">
                      <input class="form-control form-control-sm"
                             [(ngModel)]="editTeacher.lName">
                    </ng-template>
                  </td>

                  <!-- EMAIL (read only) -->
                  <td>{{ teacher.email }}</td>

                  <!-- SCHOOL -->
                  <td>
                    <ng-container *ngIf="editingIndex !== i; else editSchool">
                      {{ teacher.school }}
                    </ng-container>
                    <ng-template #editSchool>
                      <select class="form-select form-select-sm" [(ngModel)]="editTeacher.school">
                        <option value="" disabled selected>Select School</option>
                        <option *ngFor="let s of schools" [value]="s.name">
                          {{ s.name }}
                        </option>
                      </select>
                    </ng-template>
                  </td>

                  <!-- GRADE -->
                  <td>
                    <ng-container *ngIf="editingIndex !== i; else editGrade">
                      {{ teacher.grade }}
                    </ng-container>
                    <ng-template #editGrade>
                      <select class="form-select form-select-sm" [(ngModel)]="editTeacher.grade">
                        <option value="" disabled selected>Select grade</option>
                        <option value="All Grades">All Grades</option>
                        <option value="K">K</option>
                        <option value="1st">1st</option>
                        <option value="2nd">2nd</option>
                        <option value="3rd">3rd</option>
                        <option value="4th">4th</option>
                        <option value="5th">5th</option>
                        <option value="6th">6th</option>
                        <option value="7th">7th</option>
                        <option value="8th">8th</option>
                        <option value="9th">9th</option>
                        <option value="10th">10th</option>
                        <option value="11th">11th</option>
                        <option value="12th">12th</option>
                      </select>
                    </ng-template>
                  </td>

                  <!-- ROLE -->
                  <td>
                    <ng-container *ngIf="editingIndex !== i; else editRole">
                      {{ teacher.role }}
                    </ng-container>
                    <ng-template #editRole>
                      <select class="form-select form-select-sm" [(ngModel)]="editTeacher.role">
                        <option value="" disabled selected>Role</option>
                        <option value="Admin">Admin</option>
                        <option value="Teacher">Teacher</option>
                        <option value="GHS Teacher Representative">GHS Teacher Representative</option>
                        <option value="Science Directors">Science Directors</option>
                      </select>
                    </ng-template>
                  </td>

                  <!-- ACTION -->
                  <td>
                    <button *ngIf="editingIndex !== i"
                            class="btn btn-sm btn-outline-primary me-1"
                            (click)="startEdit(i, teacher)">
                      Edit
                    </button>
                    <button class="btn btn-sm" *ngIf="editingIndex !== i"
                            [ngClass]="teacher.isActive ? 'btn-outline-success' : 'btn-outline-danger'"
                            (click)="setActivation(teacher)">
                      {{ teacher.isActive ? 'Active' : 'Inactive' }}
                    </button>

                    <div *ngIf="editingIndex === i" class="d-flex gap-1">
                      <button class="btn btn-sm" id="save-btn"
                              (click)="saveEdit()">
                        Save
                      </button>
                      <button class="btn btn-sm" id="cancel-btn"
                              (click)="cancelEdit()">
                        Cancel
                      </button>
                    </div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</main>
